<!-- Only show in development mode -->
@if (isDevMode) {
<div class="dev-tools" [class.open]="isOpen">
  <!-- Toggle Button -->
  <button class="dev-tools-toggle" (click)="togglePanel()" [attr.aria-label]="'Toggle dev tools'">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M12 15l-4-4h8l-4 4z"/>
      <circle cx="12" cy="12" r="10"/>
    </svg>
  </button>

  <!-- Dev Tools Panel -->
  <div class="dev-tools-panel">
    <div class="panel-header">
      <h3>🛠️ Dev Tools</h3>
      <button class="close-btn" (click)="togglePanel()" [attr.aria-label]="'Close'">×</button>
    </div>

    <div class="panel-content">
      <!-- Mock User Info Display -->
      @if (simulateMainApp) {
        <div class="tool-section user-info-section">
          <h4>👤 Mock User Info</h4>
          <div class="user-info-grid">
            <div class="info-row">
              <span class="info-label">Phone:</span>
              <span class="info-value">{{ mockUserInfo.username }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">User ID:</span>
              <span class="info-value">{{ mockUserInfo.userid }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Language:</span>
              <span class="info-value">{{ mockUserInfo.lang }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Token:</span>
              <span class="info-value token">{{ mockUserInfo.token.substring(0, 20) }}...</span>
            </div>
          </div>
        </div>
      }

      <!-- Language Selector -->
      <div class="tool-section">
        <h4>Language</h4>
        <div class="language-buttons">
          <button 
            class="lang-btn"
            [class.active]="languageService.currentLanguage() === 'lo'"
            (click)="switchLanguage('lo')">
            🇱🇦 ລາວ
          </button>
          <button 
            class="lang-btn"
            [class.active]="languageService.currentLanguage() === 'en'"
            (click)="switchLanguage('en')">
            🇬🇧 English
          </button>
        </div>
      </div>

      <!-- Main App Simulation Toggle -->
      <div class="tool-section">
        <h4>Simulate Main App</h4>
        <div class="toggle-container">
          <label class="toggle-switch">
            <input 
              type="checkbox" 
              [checked]="simulateMainApp"
              (change)="toggleSimulation()"
              [disabled]="isInWebView">
            <span class="toggle-slider"></span>
          </label>
          <span class="toggle-label">
            {{ simulateMainApp ? 'Simulation Enabled' : 'Using Real App' }}
          </span>
        </div>
        @if (isInWebView) {
          <p class="help-text warning">
            ⚠️ Running in WebView - simulation not needed
          </p>
        } @else {
          <p class="help-text">
            Enable to simulate user info from main app. Page will reload when toggled.
          </p>
        }
      </div>
    </div>
  </div>
</div>
}
